import React from 'react';
import TravelLanding from './TravelLanding';

function App() {
  return (
    <div className="App">
      <TravelLanding />
    </div>
  );
}

export default App;